import React from 'react';
import { useFiltersContext } from '@/creditflowresearch/application/FiltersContext';
import { SEARCH_PLACEHOLDER } from '@/creditflowresearch/ui/components/bonds/constants';
import SearchInput from '@/creditflowresearch/ui/common/components/molecules/SearchInput';
import { useInventoryTableContext } from '@/creditflowresearch/application/Bonds/InventoryTableContext';
import { useBwicTableContext } from '@/creditflowresearch/application/Bonds/BwicTableContext';
import useGetBondsPayload from '@/creditflowresearch/application/Bonds/useGetBondsPayload';

import bondStyles from '../bonds.module.scss';

const SearchInputContainer = (props) => {
  const config = {
    name: 'searchBonds',
    placeholder: SEARCH_PLACEHOLDER,
  };
  const {
    onSearch,
    params: { search },
  } = useFiltersContext();
  const { debouncedGetInventories } = useInventoryTableContext();
  const { debouncedGetBwics } = useBwicTableContext();
  const { getPayload } = useGetBondsPayload();

  const onChange = ({ target: { value } }) => {
    onSearch(value);
    debouncedGetInventories(getPayload({
      params: {
        search: value,
        page: 1,
      },
    }));
    debouncedGetBwics(getPayload({
      params: {
        search: value,
        page: 1,
      },
    }));
  };

  return (
    <SearchInput
      { ...props }
      { ...config }
      formFieldClassName={ bondStyles.searchFormField }
      value={ search }
      onChange={ onChange }
      dataTest="formSearchInput"
    />
  );
};

export default SearchInputContainer;
